import React from "react";

function EmptyLog() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 24 24"
    >
      <path
        fill="#cae8ff"
        d="M17 2H7a3.009 3.009 0 00-3 3v14a3.009 3.009 0 003 3h7a1.033 1.033 0 00.71-.29l5-5A1.033 1.033 0 0020 16V5a3.009 3.009 0 00-3-3z"
        data-original="#cae8ff"
      ></path>
      <path
        fill="#14a7ff"
        d="M20 16a1.033 1.033 0 01-.29.71l-5 5A1.033 1.033 0 0114 22v-4a2.006 2.006 0 012-2z"
        data-original="#14a7ff"
      ></path>
    </svg>
  );
}

export default EmptyLog;